import assertString from './util/assertString.js';
import merge from './util/merge.js';

var default_is_empty_options={ignore_whitespace:false};function isEmpty(str,options){assertString(str);options=merge(options,default_is_empty_options);return (options.ignore_whitespace?str.trim().length:str.length)===0}

export { isEmpty as default };
//# sourceMappingURL=isEmpty.js.map
